import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { disableScrolling, enableScrolling } from '../utils/helpers';

gsap.registerPlugin(ScrollTrigger);
class Header {
  constructor(wWidth) {
    this.wWidth = wWidth;
    this.isOrderOpened = false;
    this.headerOpened = false;

    this.$header = $('.header');
    this.$hamburger = this.$header.find('.hamburger');

    this.init();
    this.onScroll();
  }

  init() {
    // toggle mobile nav
    this.$hamburger.on('click', () => {
      this.headerOpened = !this.headerOpened;
      this.$header.toggleClass('is-opened');

      if (this.wWidth >= 1024) return;
      if (this.headerOpened) {
        disableScrolling();
      } else {
        enableScrolling();
      }
    });

    $('.menu-btn').on('mouseover', function () {
      $('.header__menu').addClass('visible-ul');
      $('.header__menu').removeClass('invisible-ul');
    });

    $('header').on('mouseleave', function () {
      const scroll = $(window).scrollTop();
      if (scroll >= 1) {
        $('.header__menu').removeClass('visible-ul');
        $('.header__menu').addClass('invisible-ul');
      }
    });
  }

  onScroll() {
    // window on scroll
    $(window).on('scroll', () => {
      const scroll = $(window).scrollTop();

      if ($(window).width() > 1024) {
        if (scroll >= 1) {
          this.$header.addClass('is-scrolling');
          $('.header__menu').addClass('invisible-ul');
          $('.header__menu').removeClass('visible-ul');
        } else {
          this.$header.removeClass('is-scrolling');
          $('.header__menu').removeClass('invisible-ul');
          $('.header__menu').addClass('visible-ul');
        }
      }
    });
  }

  onResize(wWidth) {
    this.wWidth = wWidth;

    // if header opened, close it
    if (this.headerOpened) {
      this.headerOpened = false;
      this.$header.removeClass('is-opened');
      enableScrolling();
    }
  }
}

export default Header;
